module.exports = __webpack_public_path__ + "static/volunteer_profile3@2x-9f531aeec7d33e66ca869a5e925bf98f.png";